import React from 'react';
import { TinyTitleBold } from '@kvdbil/components';
import styled from 'styled-components';
import { Close } from '~/App/shared/components/IconButtons/Close';
import { GoBack } from '~/App/shared/components/IconButtons/GoBack';

const ChildrenContainer = styled.div`
  padding: 2rem;
  height: 100%;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 1rem;
`;

const HeaderStart = styled.div`
  display: flex;
  align-items: center;
`;

const MenuTitle = styled(TinyTitleBold)`
  text-align: center;
  width: 100%;
  font-size: 1rem;
`;

type Props = {
  title?: string;
  onBack?(): void;
  onClose?(): void;
  startSlot?: React.ReactNode;
  children: React.ReactNode;
};

export const MenuViewContainer = ({
  title = '',
  onBack,
  onClose,
  startSlot,
  children
}: Props) => {
  return (
    <>
      {(onBack || onClose || startSlot) && (
        <Header>
          {onBack ? (
            <GoBack onClick={onBack} />
          ) : (
            startSlot && <HeaderStart>{startSlot}</HeaderStart>
          )}

          {title && <MenuTitle>{title}</MenuTitle>}

          {onClose && <Close onClick={onClose} />}
        </Header>
      )}
      <ChildrenContainer>{children}</ChildrenContainer>
    </>
  );
};
